module.exports = __webpack_public_path__ + "static/media/kitty-pryde-lose.4516e97a.png";